import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchAddressAreaByPin } from "../../service/AddressApi"; // Assuming this is defined in the service file
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../components/shared"; // Assuming you have a loading component
import { useCheckAccess } from "../../utils/Utilities";
import '../general/General.css';
import { useNavigate } from "react-router-dom";

function AddressAreaView() {
  useCheckAccess('AddressRO'); // Check if the user is logged in (if no user data, redirect to login)
  const navigate = useNavigate();
  const { pincode } = useParams(); // Get pincode from URL parameters
  const [addressAreas, setAddressAreas] = useState([]); // Initialize as an array
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Fetch address area data by pincode
  useEffect(() => {
    if (pincode) {
      setLoading(true);
      setError(""); // Reset previous errors
      fetchAddressAreaByPin(pincode, 'false')
        .then((data) => {
          setAddressAreas(data?.addressAreaList || []);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message); // Set error if the fetch fails
          setLoading(false);
        });
    } else {
      setError("Invalid PIN received");
      setLoading(false);
    }
  }, [pincode]);
  // Display loading or error states
  if (loading) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>

    );
  }

  if (error) {
    return (
      <Loading />
    );
  }
  return (
    <>
      <Navbar />
      <Helmet>
        <title>பின்னுக்கான அஞ்சல் விவரங்கள்</title>
        <link rel="canonical" href="/address-area/view" />
      </Helmet>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <button onClick={() => navigate("/address/admin")}>முகவரி நிர்வாகி பக்கம்</button>
            <br />
            <button onClick={() => navigate("/address-area/create")}>அஞ்சலை உருவாக்கு</button>
          </div>
        </div>
      </div>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <h3>பின்னுக்கான அஞ்சல்கள்: {pincode}</h3>
            <br />




            {/* Correctly check if addressAreas is not empty */}
            {addressAreas.length > 0 ? (
              addressAreas.map((area) => (
                <div key={area.id} style={{ marginBottom: '20px' }}>
                  <hr />
                  <h3>{area.name},{area.block},{area.district} ({area.name_tamil},{area.block_tamil},{area.district_tamil})</h3>
                  <br />
                  <ul>
                    {/* Render subareas */}
                    {Array.isArray(area.subAreas) && area.subAreas.length > 0 && (
                      <div>
                        {area.subAreas.map((subarea) => (
                          <div key={subarea.id}>
                            <li>
                              ஊர் எண்: {subarea.id}
                              <br />
                              {/* Render subarea names depending on its structure */}
                              {subarea ? (
                                typeof subarea === "object" ? (
                                  <>
                                    {/* Tokenize and reverse subarea.name.name */}
                                    <div>
                                      {'ஊர்:'}{subarea.name.split("|").reverse().map((token, i) => (
                                        <div key={`name-${i}`}>{token}</div>
                                      ))}
                                      {'அஞ்சல்:'}{area.name}
                                      {' தாலுக்கா:'}{area.block}
                                      {' மாவட்டம்:'}{area.district}
                                      <br />
                                      {area.state},{area.pincode}
                                    </div>
                                    {/* Tokenize and reverse subarea.name.name_tamil */}
                                    <div>
                                      {'ஊர்:'}{subarea.name_tamil.split("|").reverse().map((token, i) => (
                                        <div key={`name_tamil-${i}`}>{token}</div>
                                      ))}
                                      {' அஞ்சல்:'}{area.name_tamil}
                                      {' தாலுக்கா:'}{area.block_tamil}
                                      {' மாவட்டம்:'}{area.district_tamil}
                                      <br />
                                      {area.state_tamil},{area.pincode}
                                    </div>
                                  </>
                                ) : (
                                  <div>{subarea.name}</div>
                                )
                              ) : (
                                <div>ஊர் கிடைக்கவில்லை</div>
                              )}
                            </li>
                          </div>
                        ))}
                      </div>
                    )}
                  </ul>
                </div>
              ))
            ) : (
              <p>கொடுக்கப்பட்ட பின்கோடுக்கு எந்த அஞ்சலும் கிடைக்கவில்லை</p>
            )}
            <button onClick={() => navigate(`/address-sub-area/update/${pincode}`)}>ஊர் புதுப்பிக்கவும்</button>
            <br />
            <button onClick={() => navigate(`/address-area/update/${pincode}`)}>அஞ்சல் புதுப்பிக்கவும்</button>
          </div>
        </div>
      </div>
      <br />
      <Footer />
    </>
  );
}
export default AddressAreaView;